export default "__VITE_ASSET__DYEUjAfy__"